/**
 * Spine-ready contract: swap this implementation for a Spine-backed adapter later.
 * All visual motion for “character” symbols and UI feedback should use this API.
 */
export class SpineAdapter {
  /**
   * @param {string} _animationName Logical animation id (e.g. from gameConfig.animations).
   */
  play(_animationName) {
    throw new Error('SpineAdapter.play must be implemented');
  }

  stop() {
    throw new Error('SpineAdapter.stop must be implemented');
  }

  setIdle() {
    throw new Error('SpineAdapter.setIdle must be implemented');
  }

  /** Optional hook for pooled symbols */
  reset() {
    this.stop();
    this.setIdle();
  }
}
